var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.848C11.75 18.848 11.49 18.7559 11.29 18.5717L8.71002 16.2596C7.74001 15.3899 7.61001 13.8963 8.42002 12.8629C9.24002 11.8194 10.7 11.625 11.75 12.4333L12 12.6276L12.26 12.423C13.31 11.6148 14.77 11.8092 15.59 12.8527C16.4 13.886 16.27 15.3797 15.3 16.2493L12.72 18.5615C12.51 18.7559 12.25 18.848 12 18.848ZM9.69001 15.1035L12 17.1701L14.31 15.1035C14.68 14.7761 14.73 14.2134 14.42 13.8246C14.11 13.4256 13.56 13.354 13.16 13.6609L12.45 14.2032C12.18 14.4078 11.82 14.4078 11.55 14.2032L10.84 13.6609C10.45 13.354 9.89002 13.4256 9.58002 13.8246C9.28001 14.2134 9.33001 14.7761 9.69001 15.1035Z",
    fill: "#101828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.8302H7C2.59 23.8302 1.25 22.4592 1.25 17.9475V7.71668C1.25 3.20491 2.59 1.83398 7 1.83398H8.5C10.25 1.83398 10.8 2.41714 11.5 3.3686L13 5.41476C13.33 5.86491 13.38 5.9263 14 5.9263H17C21.41 5.9263 22.75 7.29722 22.75 11.809V17.9475C22.75 22.4592 21.41 23.8302 17 23.8302ZM7 3.3686C3.42 3.3686 2.75 4.06429 2.75 7.71668V17.9475C2.75 21.5998 3.42 22.2955 7 22.2955H17C20.58 22.2955 21.25 21.5998 21.25 17.9475V11.809C21.25 8.1566 20.58 7.46091 17 7.46091H14C12.72 7.46091 12.3 7.01076 11.8 6.33553L10.3 4.28937C9.78 3.58345 9.62 3.3686 8.5 3.3686H7Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFavorite);
export default __webpack_public_path__ + "static/media/folder-favorite.d3685e4c8c930c5f587078fd7fa449d7.svg";
export { ForwardRef as ReactComponent };